export default __webpack_public_path__ + "static/media/helpinghearts_logo.056cf681.jpg";